import { Star } from "lucide-react";
import { ProfileInfoDataInterface } from "@/modules/Astro/UserProfile/ProfilesInfo/profileTypes";
import styles from "./ReviewsSection.module.scss";

function formatRelativeDate(dateStr: string): string {
  const diffMs = Date.now() - new Date(dateStr).getTime();
  const diffDays = Math.floor(diffMs / 86_400_000);
  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "1 day ago";
  if (diffDays < 7) return `${diffDays} days ago`;
  if (diffDays < 14) return "1 week ago";
  if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
  if (diffDays < 60) return "1 month ago";
  if (diffDays < 365) return `${Math.floor(diffDays / 30)} months ago`;
  return `${Math.floor(diffDays / 365)} year${Math.floor(diffDays / 365) > 1 ? "s" : ""} ago`;
}

interface ReviewsSectionProps {
  userData?: ProfileInfoDataInterface;
}

export default function ReviewsSection({ userData }: ReviewsSectionProps) {
  const reviews = userData?.rnr?.rating?.commentedReview ?? [];

  return (
    <section className={styles.card}>
      <div className={styles.heading}>
        <span className={styles.bar}></span>

        <h2>Client Reviews</h2>
      </div>

      <div className={styles.list}>
        {reviews.length === 0 ? (
          <p className={styles.noReviews}>No reviews yet.</p>
        ) : (
          reviews.map((item) => (
            <div className={styles.review} key={item.id}>
              <div className={styles.avatar}>
                {item.reviewerName?.charAt(0) ?? "?"}
              </div>

              <div className={styles.content}>
                <div className={styles.top}>
                  <h4>{item.reviewerName}</h4>

                  <span>{formatRelativeDate(item.createdAt)}</span>
                </div>

                <p>{item.comment}</p>

                <div className={styles.rating}>
                  {Array.from({ length: Math.min(5, Math.max(0, item.rating)) }).map((_, index) => (
                    <Star key={index} size={14} fill="currentColor" />
                  ))}
                </div>

                {item.reviewItems && item.reviewItems.length > 0 && (
                  <div className={styles.tagsContainer}>
                    {item.reviewItems.map((tag, idx) => (
                      <span key={idx} className={styles.tagChip}>
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </section>
  );
}
